import { useEffect, useState } from 'react'
import { SystemLogsQuery, useSystemLogs } from 'api'
import LogsList from 'log-viewer/LogsList'
import Typography from '@material-ui/core/Typography'
import { strings } from 'strings'

interface Props {
  mountpointName: string
  startDate: Date
}
const MountpointSystemLogs = ({ mountpointName, startDate }: Props) => {
  const [query, setQuery] = useState<SystemLogsQuery>()

  useEffect(() => {
    setQuery({
      Count: 100,
      Filter: mountpointName,
      After: startDate.getTime() / 1000,
    })
  }, [startDate])

  const { data } = useSystemLogs(query)

  const logs = data
    ? typeof data === 'object'
      ? [data]
      : data
          .split('\r\n')
          .slice(0, -1)
          .map((line) => JSON.parse(line))
          .sort((a, b) => b.ts - a.ts)
    : []

  if (!logs || logs?.length === 0) return null

  return (
    <div style={{ width: '100%' }}>
      <Typography>{strings.logsList}</Typography>
      <LogsList logs={logs} />
    </div>
  )
}

export default MountpointSystemLogs
